<script lang="ts">
  export let text: string;
  export let scrambleSpeed: number = 50;
  export let scrambledLetterCount: number = 8;
  export let characters: string = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz!@#$%^&*()_+";
  export let className: string = "";
  export let triggerOnView: boolean = true;

  let display = "";
  let interval: any;
  let revealed = false;
  let el: HTMLElement;
  let hasAnimated = false;

  function scramble() {
    let progress = 0;
    revealed = false;
    interval = setInterval(() => {
      if (progress < text.length) {
        let scrambled = text
          .split("")
          .map((char, i) =>
            i <= progress
              ? char
              : characters[Math.floor(Math.random() * characters.length)]
          )
          .join("");
        display = scrambled;
        progress++;
      } else {
        display = text;
        revealed = true;
        clearInterval(interval);
      }
    }, scrambleSpeed);
  }

  function handleInView(entries: IntersectionObserverEntry[]) {
    if (!hasAnimated && entries[0].isIntersecting) {
      scramble();
      hasAnimated = true;
    }
  }

  import { onMount, onDestroy } from "svelte";
  let observer: IntersectionObserver;
  onMount(() => {
    if (triggerOnView) {
      observer = new IntersectionObserver(handleInView, { threshold: 0.1 });
      if (el) observer.observe(el);
    } else {
      scramble();
    }
  });
  onDestroy(() => {
    clearInterval(interval);
    if (observer && el) observer.disconnect();
  });
</script>

<div bind:this={el} class={className} aria-label={text}>{display}</div> 